import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { ModalGopVon } from "./ModalGopVon";

export const BtnGopVon = ({ item }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <a href={() => false} onClick={handleShow}>
        <PopoversBootrap
          contentText="Góp vốn"
          titleText=""
          trigger={["hover", "focus"]}
          placement={"top"}
        >
          <img src="/app-assets/images/icon-gop-von-v2.png" />
        </PopoversBootrap>
      </a>

      {show && (
        <ModalGopVon
          show={show}
          onHide={handleClose}
          customerId={item.CustomerID}
          item={item}
        />
      )}
    </>
  );
};
